import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { Modal } from "@lib/modal";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { CashoutLocation } from "@utils/common/cashoutLocation";

export default observer(function CashoutCounter(props: {
	store: CashoutStore | undefined;
	isMini: boolean;
}) {
	const { t } = useTranslation();

	if (props.store == undefined) {
		return null;
	}

	if (
		props.store.isCountdownVisible &&
		props.store.countdownCounter > 0 &&
		props.isMini &&
		props.store.cashoutLocation == CashoutLocation.MY_BETS
	) {
		return (
			<div className="loader--countdown is-mini">
				<div className="loader--countdown__inner is-mini">
					<div className="loader--countdown__box">
						{props.store.countdownCounter}
					</div>
					<div className="loader--countdown__title">
						{t<string>("HOME.LOADING")}...
					</div>
				</div>
			</div>
		);
	}

	if (
		props.store.isCountdownVisible &&
		props.store.countdownCounter > 0 &&
		!props.isMini &&
		props.store.cashoutLocation == CashoutLocation.MY_BETS
	) {
		return (
			<Modal>
				<div id="loader" className="loader--full">
					<div className="loader--countdown">
						<div className="loader--countdown__box">
							{props.store.countdownCounter}
						</div>
						<div className="loader__title u-type--color--white">
							<>{t("HOME.LOADING")}...</>
						</div>
					</div>
				</div>
			</Modal>
		);
	}

	if (
		props.store.isCountdownVisible &&
		props.store.countdownCounter > 0 &&
		props.store.cashoutLocation == CashoutLocation.OFFER
	) {
		return (
			<Modal>
				<div id="loader" className="loader--full">
					<div className="loader--countdown">
						<div className="loader--countdown__box">
							{props.store.countdownCounter}
						</div>
						<div className="loader__title u-type--color--white">
							<>{t("HOME.LOADING")}...</>
						</div>
					</div>
				</div>
			</Modal>
		);
	}

	if (
		props.store.isCashoutFormSubmitting &&
		props.isMini &&
		props.store.cashoutLocation == CashoutLocation.MY_BETS
	) {
		return (
			<div className="loader--countdown is-mini">
				<div className="loader--countdown__inner is-mini">
					<div className="loader__card">
						<div className="loader__spinner u-display--b" />
						<div className="loader__title u-type--color--white">
							<>{t("HOME.LOADING")}...</>
						</div>
					</div>
				</div>
			</div>
		);
	}

	if (
		props.store.isCashoutFormSubmitting &&
		props.isMini &&
		props.store.cashoutLocation == CashoutLocation.OFFER
	) {
		return (
			<Modal>
				<div id="loader" className="loader--full">
					<div className="loader__card">
						<div className="loader__spinner u-display--b" />
						<div className="loader__title u-type--color--white">
							<>{t("HOME.LOADING")}...</>
						</div>
					</div>
				</div>
			</Modal>
		);
	}

	if (
		props.store.isCashoutFormSubmitting &&
		!props.isMini &&
		props.store.cashoutLocation == CashoutLocation.MY_BETS
	) {
		return (
			<Modal>
				<div id="loader" className="loader--full">
					<div className="loader__card">
						<div className="loader__spinner u-display--b" />
						<div className="loader__title u-type--color--white">
							<>{t("HOME.LOADING")}...</>
						</div>
					</div>
				</div>
			</Modal>
		);
	}

	return null;
});
